function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "chromedefault-a",
  x1: "0%",
  x2: "100%",
  y1: "50%",
  y2: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#3E82F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#2F75EB"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(16 8)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F7C43B",
  d: "M0,16 C4.418278,16 8,12.418278 8,8 C8,3.581722 4.418278,3.10862447e-13 0,3.10862447e-13 L13.8594849,1.54543045e-13 C15.2208447,2.35338349 16,5.08570101 16,8 C16,16.836556 8.836556,24 0,24 L0,16 Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E8BB3F",
  d: "M6.69489146,3.61901933 C5.26575124,1.43948056 2.80097997,2.5313085e-14 7.54951657e-14,2.5313085e-14 L13.8309859,2.5313085e-14 L6.69489146,3.61901933 Z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 6.292)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0CA260",
  d: "M3.28058143,1.54987134e-13 L9.85062739,4.59042513 C8.69510852,5.97743024 8,7.76148483 8,9.70789071 C8,14.1261687 11.581722,17.7078907 16,17.7078907 C18.7384767,17.7078907 21.1555821,16.3319368 22.5976792,14.233666 L16,25.7078907 C7.163444,25.7078907 -4.79616347e-14,18.5444467 -4.79616347e-14,9.70789071 C-4.79616347e-14,6.05735031 1.22255983,2.69235406 3.28058143,2.46469511e-14 Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#079356",
  d: "M16.8853276,17.659458 C19.2550646,17.3985683 21.3131585,16.1026609 22.5976792,14.233666 L16,25.7078907 L16.8853276,17.659458 Z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.162)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#DA483B",
  d: "M13.5962964,8.00358394 C9.28986943,8.13141385 5.83808068,11.6626027 5.83808068,16 C5.83808068,16.6905991 5.92558669,17.3607602 6.09011565,18 L6.08756503,18 L1.19904087e-13,7.96311216 C2.77168737,3.20105105 7.93106126,1.77635684e-15 13.8380807,1.77635684e-15 C19.7603377,1.77635684e-15 24.931087,3.21758704 27.697563,7.99999555 L13.5962964,8 L13.5962964,8.00358394 Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D4463A",
  d: "M6.10806641,18.0704085 L0.037565034,7.98691629 L6.53546368,12.7272307 C6.08701646,13.7262542 5.83756503,14.8339958 5.83756503,16 C5.83756503,16.7159997 5.93162643,17.4100301 6.10806641,18.0704085 Z"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 6,
  fill: "url(#chromedefault-a)"
}));

var SvgChromeDefault = function SvgChromeDefault(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChromeDefault, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ChromeDefault.107f60a4.svg";
export { ForwardRef as ReactComponent };